module.exports = __webpack_public_path__ + "static/media/LoveOrReturnIt.824e390c.svg";